// Global vars
let map = null;
const icon = new google.maps.MarkerImage(
    '/img/map/location-map.png',
    null, /* size is determined at runtime */
    null, /* origin is 0,0 */
    null, /* anchor is bottom center of the scaled image */
    new google.maps.Size(30, 45)
);
const form = document.querySelector('#rijscholenNew #search form');
const locHolder = document.querySelector('#rijscholenNew #locations .locations');

document.addEventListener('DOMContentLoaded', function() {
    if (form.querySelector('#query').value !== '') {
        const zipcodeCheck = /^[1-9][0-9]{3}[\s]?[A-Za-z]{2}$/i;
        if (zipcodeCheck.test(form.querySelector('#query').value) || form.querySelector('#query').value === '') {
            formData = new FormData(form);
            getRijscholen(formData);

            window.scrollTo({
                top: document.querySelector('#locations').offsetTop - 140,
                behavior: 'smooth'
            });
        } else {
            createPopup('error', 'Dit is geen geldige postcode!');
        }
    } else {
        getRijscholen({query: ""});
    }

    form.addEventListener('submit', function(ev) {
        ev.preventDefault();

        const zipcodeCheck = /^[1-9][0-9]{3}[\s]?[A-Za-z]{2}$/i;
        if (zipcodeCheck.test(form.querySelector('#query').value) || form.querySelector('#query').value === '') {
            formData = new FormData(form);
            getRijscholen(formData);

            window.scrollTo({
                top: document.querySelector('#locations').offsetTop - 140,
                behavior: 'smooth'
            });
        } else {
            createPopup('error', 'Dit is geen geldige postcode!');
        }
    });
});

const getRijscholen = function(data) {
    const XHR = new XMLHttpRequest();
    XHR.open('POST', '/request/locationsNew');
    XHR.send(data);

    XHR.onload = function () {
        if (XHR.status === 200) {
            maps(XHR.response);
        } else if (XHR.status === 404) {
            // Handle the case when postcode is not found
            const response = JSON.parse(XHR.response);
            createPopup('error', response.error || 'Postcode niet gevonden');
            clearLocations();
        }
    }
}

const clearLocations = function() {
    locHolder.innerHTML = '';
    if (map) {
        map.setCenter(new google.maps.LatLng(52.132633, 5.291266)); // Center of Netherlands
        map.setZoom(7);
    }
}

const setLocations = function(locations) {
    locHolder.innerHTML = '';

    Array.prototype.slice.call(locations).forEach(function (location, i) {
        if (i < 6) {
            locHolder.innerHTML += createItem(location);
        }
    });
}

const maps = function(data) {
    let markers = new Array();
    const bounds = new google.maps.LatLngBounds();

    // Parsing JSON
    let locations = JSON.parse(data);

    // Set location divs
    setLocations(locations);

    if (locations.length === 6) {
        document.querySelector('#locations').classList.add('active');
    } else if (document.querySelector('#locations').classList.contains('active')) {
        document.querySelector('#locations').classList.remove('active');
    }

    if (window.innerWidth > 767) {

        // Initiate map
        map = new google.maps.Map(document.querySelector('#maps'), {});

        // Loop through locations
        Array.prototype.slice.call(locations).forEach(function (location, i) {
            let marker = new google.maps.Marker({
                position: new google.maps.LatLng(location.latitude, location.longitude),
                map: map,
                icon: icon
            });

            // if (locations.length === 6) {
            //     locHolder.innerHTML += createItem(location);
            // }

            bounds.extend(marker.position);

            google.maps.event.addListener(marker, 'click', (function (marker, i) {
                return function () {
                    infoBubble = new InfoBubble({
                        map: map,
                        content: '<div class="infobubble">\n\
									<h3 class="title">' + locations[i].name + '</h3>\n\
									<p style="margin-bottom: 0; padding-bottom: 0;">\n\
										<strong>' + locations[i].street + ' ' + locations[i].housenumber + '</strong><br>\n\
									   ' + locations[i].zipcode + ' ' + locations[i].city + '<br>\n\
									   T. ' + locations[i].phone + '<br>\n\
									</p>\n\
									<a href="/rijscholen/' + slugify(locations[i].name) + '-' + locations[i].id + '" class="btn btn-orange bubblebtn">Meer informatie</a>\n\
									<form action="/gratis-proefles" method="POST">\n\
										<input type="hidden" name="_token" value="' + $('meta[name="csrf-token"]').attr('content') + '">\n\
										<input type="hidden" name="id" value="' + locations[i].id + '">\n\
										<button class="btn btn-white">Gratis proefles</button>\n\
									</form>\n\
								</div>',
                        shadowStyle: 0,
                        padding: 0,
                        borderRadius: 5,
                        arrowSize: 15,
                        borderWidth: 0,
                        minWidth: 320,
                        maxWidth: 320,
                        closeSrc: '../img/infobubble_close.svg',
                        backgroundColor: '#00B6FE',
                        borderWidth: '3px',
                        borderColor: '#ffffff'
                    });

                    $('#rijscholen .rijscholen').slick('slickGoTo', i);

                    infoBubble.open(map, marker);
                }
            })(marker, i));

            markers.push(marker);
        });

        map.fitBounds(bounds);

        const renderer = {
            render: function ({count, position}, stats, map) {
                const svg = `<svg fill="#00B7FF" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="60" height="60">
                                        <circle cx="120" cy="120" opacity="1" r="70" />
                                        <text x="50%" y="52%" style="fill:#fff; font-weight: bold;" text-anchor="middle" font-size="45" dominant-baseline="middle" font-family="roboto,arial,sans-serif">${count}</text>
                                        </svg>`;
                const title = `Cluster of ${count} markers`,
                    zIndex = Number(google.maps.Marker.MAX_ZINDEX) + count;

                const clusterOptions = {
                    position,
                    zIndex,
                    title,
                    icon: {
                        url: `data:image/svg+xml;base64,${btoa(svg)}`,
                        anchor: new google.maps.Point(35, 35),
                    },
                };
                return new google.maps.Marker(clusterOptions);
            }
        }

        const markerCluster = new markerClusterer.MarkerClusterer({map, markers, renderer});
    }

}

const createItem = function(location) {
    let item = '<a href="/rijscholen/' + slugify(location.name) + '-' + location.id + '" class="col-xs-12 col-sm-6 col-md-4 location">' +
                '    <div class="inner">' +
                '        <h3>' + location.name_instructor + '</h3>' +
                '        <p>' + location.street + ' ' + location.housenumber + location.housenumber_additions + '<br />' + location.zipcode + ' ' + location.city + '</p>' +
                '        <button class="rbtn">Meer info</button>' +
                '    </div>' +
                '</a>';

    return item;
}

// Create popup with a message
const createPopup = function (type, text) {
    const popup = document.querySelector('#popup');
    const title = document.querySelector('#popup .inner .title');
    const textEl = document.querySelector('#popup .inner .text');
    const close = document.querySelector('#popup .close');

    textEl.innerHTML = text;

    popup.classList.add(type);
    if (type === 'error') {
        title.innerHTML = 'Oeps!';
    }
    popup.style.opacity = '1';
    popup.style.visibility = 'visible';

    setTimeout(function () {
        popup.style.opacity = '0';
        popup.style.visibility = 'hidden';
    }, 2000)
}


function slugify(text)
{
  return text.toString().toLowerCase()
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '');            // Trim - from end of text
}